import { useCallback } from 'react';

import axios, { endpoints } from 'src/utils/axios';

import { toast } from 'src/components/snackbar';

// ----------------------------------------------------------------------

const RATING_TO_INT = { positive: 1, negative: -1 };

export function useMessageFeedback({ updateMessageById, getMessageById }) {
  const submitFeedback = useCallback(
    async (messageId, feedback) => {
      const previous = getMessageById?.(messageId)?.feedback ?? null;
      updateMessageById(messageId, (msg) => ({ ...msg, feedback }));

      try {
        if (feedback) {
          await axios.post(endpoints.knowledge.messageFeedback(messageId), {
            rating: RATING_TO_INT[feedback.rating],
            reasonCode: feedback.issueType || null,
            comment: feedback.comment || null,
          });
        } else {
          await axios.delete(endpoints.knowledge.messageFeedback(messageId));
        }
      } catch (err) {
        updateMessageById(messageId, (msg) => ({ ...msg, feedback: previous }));
        toast.error(err?.response?.data?.detail || 'Failed to submit feedback');
      }
    },
    [getMessageById, updateMessageById]
  );

  return { submitFeedback };
}
